import React from "react";
import { EuiCallOut, EuiFlexGroup, EuiFlexItem, EuiText } from "@elastic/eui";
import { useAnketaI18n } from "src/internationalization";
import { WaveDeploymentTimeline } from "src/opsanio/waves/timeline";
import { GitLabMerge, OpsanioVersions, OpsanioWaves } from "src/questionnaires";
import { OpsanioApplianceData } from "..";

export const OpsanioApplianceFlyoutWave = ({
  appliance,
  versions,
  merges,
  tags,
  loadAllData,
}: {
  appliance: OpsanioApplianceData;
  versions: Record<OpsanioWaves, OpsanioVersions>;
  merges: Record<OpsanioWaves, GitLabMerge> | null;
  tags: any;
  loadAllData: (updateLoadingState?: boolean) => Promise<void>;
}): JSX.Element => {
  const { translate } = useAnketaI18n();

  return (
    <EuiFlexGroup direction="column">
      <EuiFlexItem>
        <EuiCallOut color="warning">
          <EuiText>
            <h4>{translate("anketa.opsanio.appliance.wave.callout")}</h4>
          </EuiText>
        </EuiCallOut>
      </EuiFlexItem>
      <EuiFlexItem>
        <WaveDeploymentTimeline
          versions={versions}
          merges={merges}
          tags={tags}
          updateAction={loadAllData}
          visibleWave={appliance.content.environment}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
